import { css } from "emotion";
import H4 from "../../../components/global/H4";
import TeamBlock from "./TeamBlock";
import { Component } from "preact";
import { getSize } from "../../../utils/BrowserUtils";

const mugAdam = require("../../../assets/mugs/mug_adam_new.jpg");
const mugAna = require("../../../assets/mugs/mug_ana.jpg");
const mugAnton = require("../../../assets/mugs/mug_anton_new.jpg");
const mugJames = require("../../../assets/mugs/mug_james_new.jpg");
const mugJosh = require("../../../assets/mugs/mug_josh_new.jpg");
const mugRyan = require("../../../assets/mugs/mug_ryan.jpg");
const mugJake = require("../../../assets/mugs/mug_jake.jpg");
const mugJoel = require("../../../assets/mugs/mug_joel.jpg");
const mugJay = require("../../../assets/mugs/mug_jay.jpg");
const mugGeorgia = require("../../../assets/mugs/mug_georgia.jpg");
const mugSam = require("../../../assets/mugs/mug_sam.jpg");
const mugJeremy = require("../../../assets/mugs/mug_jeremy.jpg");
const mugJenny = require("../../../assets/mugs/mug_jenny.jpg");
const mugDiane = require("../../../assets/mugs/mug_diane.jpg");

const icArrowRight = require("../../../assets/ic_arrow_right.svg");
const icArrowLeft = require("../../../assets/ic_arrow_left.svg");

const tapePurple = require("../../../assets/tape/tape_purple.svg");
const tapeTeal = require("../../../assets/tape/tape_teal.svg");

const tape = [tapePurple, tapeTeal];

let team = [
  {
    mug: mugGeorgia,
    name: "Georgia Robertson",
    title: "New Zealand CEO",
    text: "",
    nz: true
  },
  {
    mug: mugJosh,
    name: "Joshua Ross",
    title: "Co-Founder",
    text: "The audacious numbers man, bringing back socks & sandals."
  },
  {
    mug: mugAdam,
    name: "Adam McCurdie",
    title: "Co-Founder",
    text: "The cool, calm leader who can do a mean sauna."
  },
  {
    mug: mugJames,
    name: "James Humpherson",
    title: "Head of Operations",
    text: "The charming doer with the voice that can melt a butter."
  },
  {
    mug: mugRyan,
    name: "Ryan O'Connell",
    title: "CTO",
    text:
      "The tidy architect, the unconventional developer, surprisingly funny, when you think about it."
  },
  {
    mug: mugAna,
    name: "Ana Maria Vucinic",
    title: "UX/UI Designer",
    text:
      "The ____ that makes beautiful carving lines through design, snow and water."
  },
  {
    mug: mugAnton,
    name: "Anton Goodman",
    title: "Head of Marketing",
    text:
      "A super Melbournite marketer who marinates his vegetables like his marketing plans - delicious."
  },
  {
    mug: mugJay,
    name: "Jay Jin",
    title: "Software Developer",
    text: ""
  },
  {
    mug: mugJake,
    name: "Jake Pacione",
    title: "Software Developer",
    text:
      "The chatty style master, with love of color, a true Oprah Winfrey meets Van Gogh."
  },
  {
    mug: mugJoel,
    name: "Joel Berta",
    title: "Software Developer",
    text: "The quick-witted young gun, slow on ground, fast online."
  },
  {
    mug: mugSam,
    name: "Sam Adams Nye",
    title: "Head of Partnerships & Growth",
    text: ""
  },
  {
    mug: mugJeremy,
    name: "Jeremy Tang",
    title: "Customer Experience Manager",
    text: ""
  },
  {
    mug: mugJenny,
    name: "Jenny Chung",
    title: "Account Manager",
    text: ""
  },
  {
    mug: mugDiane,
    name: "Diane Glaser",
    title: "Head of Bookkeeping and Accounting",
    text: ""
  }
];

const teamLength = team.length;

const rowWrapper = css({
  maxWidth: 1040,
  margin: "0 auto",
  padding: "72px 100px",
  position: "relative",
  "@media(max-width: 600px)": {
    padding: "40px 14px"
  }
});

const titleWrapper = css({
  padding: "72px 14px",
  backgroundColor: "#eeecf0",
  textAlign: "center",
  h4: {
    color: "#41157a",
    margin: "0 auto"
  }
});

const memberRow = css({
  position: "relative",
  overflow: "auto",
  overflowX: "hidden",
  overflowY: "hidden",
  maxWidth: "calc(100vw - 360px)",
  margin: "0 auto",
  "@media(max-width: 600px)": {
    maxWidth: "initial",
    overflowX: "scroll"
  }
});

const previousButton = css({
  backgroundColor: "#f9f9fa",
  borderRadius: "50%",
  position: "absolute",
  top: "calc(50% - 24px)",
  left: 0,
  width: 60,
  height: 60,
  border: "none",
  backgroundImage: `url(${icArrowLeft})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "40px 40px",
  backgroundPosition: "center",
  "@media(max-width: 600px)": {
    display: "none"
  },
  "&:hover": {
    cursor: "pointer"
  }
});

const nextButton = css({
  backgroundColor: "#f9f9fa",
  borderRadius: "50%",
  position: "absolute",
  top: "calc(50% - 24px)",
  right: 0,
  width: 60,
  height: 60,
  border: "none",
  backgroundImage: `url(${icArrowRight})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "40px 40px",
  backgroundPosition: "center",
  "@media(max-width: 600px)": {
    display: "none"
  },
  "&:hover": {
    cursor: "pointer"
  }
});

class TeamMembers extends Component {
  constructor(props) {
    super(props);
    this.sortTeam();
  }

  componentDidUpdate(prevProps) {
    const { locale } = this.props;
    if (prevProps.locale !== locale) {
      this.sortTeam();
    }
  }

  sortTeam = () => {
    const { locale } = this.props;
    const teamToRandomize = team.filter(tm => {
      if (locale === "nz") {
        return !tm.nz;
      }
      return tm;
    });
    const randomisedTeam = teamToRandomize
      .map(tm => {
        const randomTapeStrip = Math.floor(Math.random() * tape.length);
        tm.tape = tape[randomTapeStrip];
        tm.order = Math.floor(Math.random() * 100);
        return tm;
      })
      .sort((a, b) => a.order - b.order);

    if (locale !== "nz") {
      this.setState({
        membersTop: randomisedTeam.splice(
          0,
          Math.ceil(randomisedTeam.length / 2)
        ),
        membersBottom: randomisedTeam,
        page: 0
      });
    } else {
      const nzMembers = team.filter(tm => {
        tm.tape = tape[randomTapeStrip];
        return tm.nz;
      });
      this.setState({
        membersTop: nzMembers.concat(
          randomisedTeam.splice(0, Math.ceil(randomisedTeam.length / 2))
        ),
        membersBottom: randomisedTeam,
        page: 0
      });
    }
  };

  nextPage = () => {
    const { page } = this.state;
    const size = getSize();
    const windowWidth = size.innerWidth < 1200 ? size.innerWidth : 1200;
    const visible = Math.ceil((windowWidth - 360) / 220) * 2;
    const pages = Math.ceil((teamLength - visible) / 2);
    if (page < pages) {
      this.setState({
        page: page + 1
      });
    }
  };

  previousPage = () => {
    const { page } = this.state;
    if (page > 0) {
      this.setState({
        page: page - 1
      });
    }
  };

  render() {
    const { locale } = this.props;
    const { membersTop, membersBottom, page } = this.state;
    const scrollWrapper = css({
      paddingBottom: 10,
      whiteSpace: "nowrap",
      transform: `translateX(-${220 * page}px)`,
      transitionDuration: "0.4s",
      transitionTimingFunction: "ease-in-out",
      "&:first-child": {
        marginBottom: 48
      },
      "@media(max-width: 600px)": {
        transform: "none"
      }
    });
    return (
      <div>
        <div className={titleWrapper}>
          <H4 maxWidth={650}>
            Rock climbers, Jazz aficionados, chef extraordinaires, mumma’s boys,
            surfers, tightrope walkers and world travellers. We’re all
            different. With one goal.
          </H4>
        </div>
        <div className={rowWrapper} id="team">
          <div className={memberRow}>
            <div className={scrollWrapper}>
              {membersTop.map(member => (
                <TeamBlock member={member} />
              ))}
            </div>
            <div className={scrollWrapper}>
              {membersBottom.map(member => (
                <TeamBlock member={member} />
              ))}
            </div>
          </div>
          <button
            onClick={this.nextPage}
            className={nextButton}
            aria-hidden={true}
            aria-label="Next two team members"
          />
          <button
            onClick={this.previousPage}
            className={previousButton}
            aria-hidden={true}
            aria-label="Previous two team members"
          />
        </div>
      </div>
    );
  }
}

export default TeamMembers;
